const ZINDEX = {
  HEADER: 1,
  MODAL: 11 /* react-table class .rt-resizer having z-index 10 */,
  ALERTCARD: 999,
  EVENT_TRIGGERED_MODAL: 20,
};

export default ZINDEX;
